<template>
  <el-card
    class="inline-goal-card inline-goal-float-effect"
    body-style="padding: 0px">

    <router-link
      :to="'/visionboard/' + visionboard.$id"
      v-tooltip="{ content: 'Go to ' + visionboard_meta.name }"
      style="position: relative">
      <div class="visionboard-overlay"></div>
      <VisionboardPreview v-if="true" />
      <!-- <div class="inline-visionboard-card__image" :style="background_image_css" ></div> -->
    </router-link>

    <div class="inline-goal-card__content">

      <inline-editable-text
        @change="onUpdateVisionboardName"
        :value="visionboard_meta.name"
        :inline="true"
        :reset-on-update="false"
        :reset-on-cancel="false"
        :lost-focus-is-update="false"
        :hide-buttons="false"
        :floating-buttons="false"
        />

      <ellipsis-button
        :disabled="true"
        class=""
        v-if="!is_deleted"
        heading="Visionboard Actions"
        :show-options="['edit', 'slot', 'archive', 'delete']"
        @edit="onGoToVisionboardSettings()"
        @archive="onClickDelete( true )"
        @delete="onClickDelete( false )">

        <el-button
          class="btn-block ml-0"
          size="mini"
          @click.prevent="onInviteUser" >
          <font-awesome-icon :icon="['fas', 'user-plus']" class="taskicon" />
          Invite user
        </el-button>

        <el-button
          class="btn-block ml-0"
          size="mini"
          @click.prevent="onClickLeaveVisionboard" >
          <font-awesome-icon icon="sign-out-alt" class="taskicon" />
          Leave visionboard
        </el-button>
      </ellipsis-button>
      <ellipsis-button
        v-else
        heading="Visionboard Actions"
        :show-options="['restore', 'delete']"
        @restore="onRestoreVisionboard"
        @delete="onClickDelete( false )">
      </ellipsis-button>
    </div>
    <div class="inline-goal-card__invite" >
      <template v-if="!is_deleted">
        <img
          v-for="(member, memberId) in visionboard_meta.members" :key="memberId"
          class="user-image"
          :src="member.cachedProfilePic|defaultUserPic"
          width="24"
          height="24"
          v-tooltip="{ content: member.cachedName }"/>
      </template>
      <template v-else>
        <strong style="color: var(--red)">You achieved or deleted this visionboard.</strong>
        <!-- <el-button variant="danger" @click="onClickDelete( false )">Remove</el-button> -->
      </template>
    </div>

  </el-card>
</template>

<script>
import EllipsisButton from '@/components/Elements/EllipsisButton'
import InvitePromptMixin from '@/components/Mixins/Prompts/InvitePrompt'
import VisionboardPreview from "./VisionboardPreview"

export default {
  mixins: [ InvitePromptMixin ],
  props: {
    visionboard: { required: true }
  },
  data: () => ({
    deleting: false
  }),
  computed: {
    visionboard_meta() {
      // return this.$models.visionboardMeta.getNode( this.visionboard.$id );
      return {
        /* Fake it till you make it */
        deleted: false,
        $id: this.visionboard.$id,
        $key: 1,
        picture: '',
        name: 'Visionboard',
        members: []
      }
    },
    is_deleted() {
      return this.visionboard_meta.deleted;
    },
    /*
    background_image_css() {
      return  this.visionboard_meta.picture
              ? {
                backgroundImage: 'url(' + this.visionboard_meta.picture + ')',
                backgroundSize: 'cover'
              } : {}
    }
    */
  },
  methods: {
    // onClickVisionboardCard() {
    //   this.$router.push({ name: 'visionboard', params: { visionboardId } });
    // },
    onUpdateVisionboardName( name ) {
      console.log("onUpdateVisionboardName", name);
      /*
      this.$api.visionboard_update_name({
        visionboard_id: this.visionboard.$id,
        name: name
      });
      */
    },
    onClickDelete( soft_delete ) {
      console.log("onClickDelete", soft_delete);
      /*

      if ( !soft_delete ) {
        this.$confirm('This will permanently delete the visionboard. Continue?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {

          this.deleting = true;
          this.$api.visionboard_delete({
            visionboard_id: this.visionboard.$id,
            soft_delete: false
          }).then(() => {

            this.deleting = false;
            this.$message({
              type: 'success',
              message: 'Delete completed'
            });
          })

        }).catch(() => {});

      } else {
        this.$api.visionboard_delete({
          visionboard_id: this.visionboard.$id,
          soft_delete: true
        })
      }
      */
    },
    onClickLeaveVisionboard() {
      console.log("onClickLeaveVisionboard", this.visionboard_id);
      /*
      this.$api.user_leave_visionboard({
        visionboard_id: this.visionboard_id,
        visionboard_exist: false
      });
      */
    },
    onGoToVisionboardSettings() {
      // TODO: OPEN MODAL
    },
    onInviteUser() {
      // TODO
      this.$invite_prompt().then(({ selection, done }) => {
        /*
        this.$api.invite_to_visionboard_by_userid({
          visionboard_id: this.visionboard.$id,
          user_id: selection.id,
          user_pic: selection.profilePic, // TODO: This should be my user profile pic
          user_name: selection.displayName
        }).then(result => {
          if ( result.message ) {
            this.$message( result.message )
          }
          done();
        })
        */
      })
    },
    onRestoreVisionboard() {
      /*
      this.$api.visionboard_update({
        deleted: false
      });
      */
    },
  },
  components: {
    EllipsisButton,
    VisionboardPreview,
  }
}
</script>

<style>
/* .inline-visionboard-card__image {
  width: 100%;
  height: 130px;
  display: block;
  min-height: 100px;

  background-color: gray;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;

  background-size: contain;
} */

.inline-goal-card:hover .visionboard-overlay {
  background-color: gray;
  background-position: center;
  background-repeat: no-repeat;
  /* position: relative; */
  background-size: contain;
  background-image: url('../../../assets/visionboard_placeholder.png');
  left: 0;
  height: 140px;
  border: 0 solid red;
  position: absolute;
  width: 210px;
  opacity: 0.5;
}

.visionboard-preview {
  width: 100%;
  height: 140px;
  margin: 0;
}
</style>
